
import React from 'react';

interface ImFeelingLuckyIconProps extends React.SVGProps<SVGSVGElement> {}

const ImFeelingLuckyIcon: React.FC<ImFeelingLuckyIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 21v-7.5A2.25 2.25 0 0 0 11.25 11.25H10.5a2.25 2.25 0 0 0-2.25 2.25V21M13.5 21H15V6.75A2.25 2.25 0 0 0 12.75 4.5H11.25A2.25 2.25 0 0 0 9 6.75V21M13.5 21H21V6.75A2.25 2.25 0 0 0 18.75 4.5H15M9 21H3V6.75A2.25 2.25 0 0 1 5.25 4.5H9M15 11.25h.008v.008H15v-.008Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 11.25h.008v.008H9v-.008ZM12 13.5h.008v.008H12v-.008Z" />
     {/* Dice icon */}
  </svg>
);

export default ImFeelingLuckyIcon;
